export default "__VITE_ASSET__73d72f59__"